import React from 'react'
import classnames from 'classnames'
import css from './styles.scss'

export interface ChipProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {
  /**
   * The text to display inside of the chip.
   */
  label: string
}

export default function Chip({ className, label, ...rest }: ChipProps) {
  return (
    <span
      className={classnames('well man inline-block', css.root, className)}
      {...rest}
    >
      {label}
    </span>
  )
}
